import React from 'react';
import { FormattedMessage } from 'react-intl/dist';

// Components

import UniversalInput from '../../../../../lib/wrappers/UniversalInput';

// Utils

import { normalizeNameOfPerson } from '../../../../../utils/normalize/normalizeNameOfPerson';

// Constants

import { THC_TYPES } from '../../../../../constants/ssap/hhmTypes/taxRelationsTypes';
import { INPUT_TYPES } from '../../../../../constants/inputs/inputTypes';



const FilersBlock = props => {
    const {
        analyzeFamily,
        coverageYear,
        householdMembers,
        hasTaxFilers,
        onFieldChange,
        ...restProps
    } = props;

    const getPotentialTaxFilersList = () => {

        return [
            ...householdMembers.map((hhm, idx) => {

                const {
                    applicantGuid,
                    name,
                    personId
                } = hhm;

                const {
                    taxRelationship
                } = analyzeFamily.getIndicatorsValues(personId);

                const isTaxFiler = taxRelationship === THC_TYPES.FILER
                    || taxRelationship === THC_TYPES.FILER_DEPENDENT;

                return (
                    <UniversalInput
                        key = { applicantGuid }
                        label = { {
                            text: 'common.input.label.non_internationalized_text',
                            labelTextReplacements: {
                                text: normalizeNameOfPerson(name)
                            }
                        } }
                        inputData = { {
                            isInputRequired: false,
                            type: INPUT_TYPES.CHECKBOX,
                            name: 'isTaxFiler',
                            classes: [ '' ],
                            checked: isTaxFiler,
                            value: isTaxFiler,
                            currentData: {},
                            disabled: false,
                            fields: [],
                        } }
                        inputActions = { {
                            onFieldChange
                        } }
                        indexInArray = { idx }
                        { ...restProps }
                    />
                );
            }),
            <UniversalInput
                key = 'hasTaxFilers'
                label = { {
                    text: 'ssap.input.label.none_of_above'
                } }
                inputData = { {
                    isInputRequired: false,
                    type: INPUT_TYPES.CHECKBOX,
                    name: 'hasTaxFilers',
                    classes: [ '' ],
                    checked: hasTaxFilers === false,
                    value: hasTaxFilers === false,
                    currentData: {},
                    fields: [ 'taxHousehold', 'thCommonParams' ],
                    reversedValue: true
                } }
                inputActions = { {
                    onFieldChange
                } }
                { ...restProps }
            />
        ];
    };

    return (
        <div className = 'subsection' >
            <p className = 'required-true' >
                <FormattedMessage
                    id = 'ssap.family_household.tax_composition.who_files_taxes'
                    values = { {
                        coverageYear: <strong>{ coverageYear }</strong>,
                        nextCoverageYear: <strong>{ coverageYear + 1 }</strong>
                    } }
                />
            </p>
            {
                getPotentialTaxFilersList()
            }
            <FormattedMessage
                id = 'ssap.family_household.tax_composition.notification'
                tagName = 'p'
            />
        </div>
    );
};

export default FilersBlock;
